import React, { Component } from 'react';
import Balance from './Balance.js';
import Deposits from './Deposits.js';
import { Link } from 'react-router-dom';
import { STATUS } from './InvoicesContainer.js';
import { translate } from 'react-i18next';
import * as $ from 'jquery';
import { event } from 'react-ga';

class Invoices extends Component {

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    //si el script de prosa ya cargo para cierto checkout id, no se puede reutilizar y cargar para otro ID, por eso hay que eliminar el script si ya existe
    var script = document.getElementById("prosaCheckout");
    if (script) {
      $(script).remove();
    }
  }

  getPaymentLink = (isExternal) => {
    if (!isExternal) {
      return {
        pathname: "/invoices/payment",
        state: {
          invoice: JSON.stringify(this.props.invoice),
          get_data_invoices: JSON.stringify(this.props.get_data_invoives_page),
        }
      };
    }

    var tokenn = this.props.folio_externo;
    return {

      pathname: "/payment/" + tokenn + "/" + this.props.invoice.folio,
      state: {
        invoice: JSON.stringify(this.props.invoice),
        get_data_invoices: JSON.stringify(this.props.get_data_invoices),
      }
    };


  }

  renderBalance = () => {
    return (
      <Balance
        get_data_invoices={this.props.get_data_invoices}
        get_data_invoives_page={this.props.get_data_invoives_page}
        total_invoices={this.props.total_invoices}
      />
    );
  }

  renderDeposits = () => {
    return (
      <Deposits
        get_data_invoices={this.props.get_data_invoices}
      />
    );
  }

  renderInvoice = (invoice, index) => {
    const { t } = this.props;
    let status;

    switch (invoice.status) {
      default:
      case STATUS.PENDING:
        status = t('dashboard.invoices.status_pending');
        break;
      case STATUS.PAID:
        status = t('dashboard.invoices.status_paid');
        break;
      case STATUS.PROCESS:
        status = t('dashboard.invoices.status_process');
        break;
    }

    return (
      <tr key={index}>
        {invoice.status !== 3 ? (
          <td className="text-center"><input type="checkbox" id={invoice.id} onChange={() => this.props.handleInvoiceClick(invoice)} checked={invoice.checked || ""} /></td>
        ) : (<td></td>)}
        <td>{invoice.remission}</td>
        {window.screen.width > 599 ? (<td>{invoice.folio}</td>) : null}
        <td>{invoice.date}</td>
        <td>{status}</td>
        <td>{"$" + parseFloat(invoice.total.toFixed(4)).toLocaleString("en-US") + " " + invoice.total_cur}</td>
        <td>
          <button type="button" onClick={() => this.props.handleInvoiceViewClick(invoice)} className="btn" data-toggle="modal" data-target=".bs-example-modal-lg">
            Ver Documentos
          </button>
        </td>
      </tr>
    );
  }

  render() {
    const { t } = this.props;
    return (
      <div className="container_invoice_externa_container">
        <div className="panel panel-default">
          <div className="panel-heading">
            <h4 className="panel-title">{t('dashboard.invoices.results')}</h4>
          </div>
          <div className="panel-body">
            <div id="invoices">
              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Selecciona <br></br>Facturas</th>
                      <th>{t('dashboard.invoices.col_remission')}</th>
                      {window.screen.width > 599 ? (<th>{t('dashboard.invoices.col_folio')}</th>) : null}
                      <th>{t('dashboard.invoices.col_date')}</th>
                      <th>{t('dashboard.invoices.col_status')}</th>
                      <th>{t('dashboard.invoices.col_total')}</th>
                      <th>Archivos</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.invoices.map((invoice, index) =>
                      this.renderInvoice(invoice, index)
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                {this.renderDeposits()}
              </div>
              <div className="col-md-12">
                {this.renderBalance()}
              </div>
            </div>
          </div>
        </div>
        {this.props.pay_invoice ? (
          <div>
            <div className="form-group text-right">
              <div id="paymente_link" className="hidden-xs hidden-sm">
                {!this.props.isExternal ?
                  (
                    <Link to={this.getPaymentLink(this.props.isExternal)}>
                      <button
                        className="btn btn-primary"
                        type="button">
                        {t('dashboard.invoices.btn_pay')}
                      </button>
                    </Link>
                  ) : (
                    <div>
                      <Link to={this.getPaymentLink(this.props.isExternal)}>
                        <button
                          className="btn btn-primary"
                          type="button">
                          {t('dashboard.invoices.btn_pay')}
                        </button>
                      </Link>
                    </div>
                  )}
              </div>
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

export default translate('common')(Invoices);



// WEBPACK FOOTER //
// ./src/dashboard/invoices/Invoices.js